import posthog from 'posthog-js'
import type { UserWithMeta } from '~/@biz_account/useUser/types'

/**
 * PostHog product eventy z FE. Prehľad v README, sekcia PostHog.
 *
 * Na FE ostáva len to, čo API nevie: klik v prehliadači. Eventy, ktoré sú zápisom v DB (registrácia, telefón,
 * Veriff schválený, zmluva, prvá investícia, prvý kredit), posiela investin-api (`@mid_core/posthog-events`)
 * s tým istým `distinct_id = user._id`.
 *
 * Každý event najprv spraví identify (`user._id`), až potom capture. Event tak patrí správnej osobe,
 * aj keď sa komponent mountne skôr ako `PostHogUserTracker` (bez `reset()` pri logoute môže byť
 * v cookie ešte predchádzajúci user — IT-179).
 * `send_instantly` = request hneď (fetch keepalive), prežije `navigate` aj redirect do Veriffu.
 */
const PostHogProductEvent = {
  VERIFF_INITIATED: 'veriff_initiated',
} as const

type PostHogProductEventName =
  (typeof PostHogProductEvent)[keyof typeof PostHogProductEvent]

type PostHogProductEventPropertiesByName = {
  [PostHogProductEvent.VERIFF_INITIATED]: {
    is_in_app_web_view: boolean
    previous_verification_status: string | null
  }
}

/** Bez `VITE_POSTHOG_KEY` sa `posthog.init` nevolá — všetky funkcie sú potom no-op. */
function isPostHogLoaded(): boolean {
  return posthog.__loaded
}

function identifyPostHogUser(user: UserWithMeta): void {
  if (!isPostHogLoaded()) return
  if (posthog.get_distinct_id() === user._id) return
  posthog.identify(user._id, { email: user.profile.email })
}

function capturePostHogProductEvent<EventName extends PostHogProductEventName>(
  user: UserWithMeta,
  eventName: EventName,
  properties: PostHogProductEventPropertiesByName[EventName]
): void {
  if (!isPostHogLoaded()) return

  identifyPostHogUser(user)
  posthog.capture(
    eventName,
    { ...properties, authentication_type: user.meta.authType },
    { send_instantly: true }
  )
}

export { PostHogProductEvent, identifyPostHogUser, capturePostHogProductEvent }
